import { ref, computed } from 'vue';

const stack = ref<string[]>([]);

export function useDialogStack() {
  const top = computed(() => {
    return stack.value[stack.value.length - 1];
  });

  function push(id: string) {
    stack.value.push(id);
  }

  function pop(id: string) {
    stack.value = stack.value.filter((item) => item !== id);
  }

  return { stack, top, push, pop };
}
